import React from "react";

// Import all the new child components
import LoginWithEmail from "./loginwithemail";
import LoginWithMobile from "./loginwithmobile";
import ForgotPassword from "./ForgetPassword";
import VerifyOTP from "./verifyotp";
import RequestConfirmed from "./requestConfirmed";
import ResetPassword from "./resetPassword";
import PasswordResetConfirmed from "./PasswordResetConfirmed";
// This component is the main layout and orchestrator
export default function LoginPopup({
  state,
  styles = {},
  props,
  handlers,
  popupType,
  isdDropdownStyles,
  PromotionBannerCss,
  siteData,
  router,
  isMobile,
}) {
  const renderForm = () => {
    switch (popupType.popupPage) {
      case "LoginWithEmail":
        return (
          <LoginWithEmail
            state={state}
            styles={styles}
            PromotionBannerCss={PromotionBannerCss}
            handlers={handlers}
            siteData={siteData}
            isMobile={isMobile}
          />
        );
      case "LoginWithMobile":
        return (
          // will be reverted to original ==> <LoginWithMobile styles={styles} handlers={handlers} isdDropdownStyles={isdDropdownStyles} PromotionBannerCss={PromotionBannerCss} siteData={siteData}    isMobile={isMobile} />
          <LoginWithEmail
            state={state}
            styles={styles}
            PromotionBannerCss={PromotionBannerCss}
            handlers={handlers}
            siteData={siteData}
            isMobile={isMobile}
          />
        );
      case "ForgotPassword":
        return (
          <ForgotPassword
            state={state}
            styles={styles}
            handlers={handlers}
            PromotionBannerCss={PromotionBannerCss}
            siteData={siteData}
            isMobile={isMobile}
          />
        );
      case "RequestConfirmed":
        return (
          <RequestConfirmed
            state={state}
            styles={styles}
            handlers={handlers}
            PromotionBannerCss={PromotionBannerCss}
            siteData={siteData}
            isMobile={isMobile}
          />
        );
      case "ResetPassword":
      case "resettokenExpiry":
        return (
          <ResetPassword
            state={state}
            styles={styles}
            handlers={handlers}
            router={router}
            PromotionBannerCss={PromotionBannerCss}
            siteData={siteData}
            isMobile={isMobile}
            popupType={popupType.popupPage}
          />
        );
      case "PasswordResetConfirmed":
      case "createConfirmed":
      case "tokenExpired":
        return (
          <PasswordResetConfirmed
            state={state}
            styles={styles}
            handlers={handlers}
            PromotionBannerCss={PromotionBannerCss}
            siteData={siteData}
            isMobile={isMobile}
            popupType={popupType.popupPage}
          />
        );
      case "VerifyOTP":
        return (
          <VerifyOTP
            state={state}
            styles={styles}
            handlers={handlers}
            PromotionBannerCss={PromotionBannerCss}
            siteData={siteData}
            isMobile={isMobile}
          />
        );
      // Add cases for "SignUp", etc. here
      default:
        // Default to email login to be safe
        return (
          <LoginWithEmail
            state={state}
            styles={styles}
            PromotionBannerCss={PromotionBannerCss}
            handlers={handlers}
            siteData={siteData}
            isMobile={isMobile}
          />
        );
    }
  };

  return (
    <div className={styles.login_flex}>
      <div className={styles.form_flex}>{renderForm()}</div>
    </div>
  );
}
